import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPolicy() {
  return (
    <main className="relative min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-24 pb-16 md:pt-32 md:pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <h1 className="font-heading text-3xl md:text-5xl font-light text-foreground-900 tracking-wide mb-2">
            プライバシーポリシー
          </h1>
          <p className="text-foreground-400 text-sm mb-12">合同会社RSE</p>

          <section className="mb-10">
            <h2 className="font-heading text-xl font-medium text-foreground-800 mb-4">
              1. 個人情報の収集について
            </h2>
            <p className="text-foreground-600 text-sm leading-loose">
              当社は、お問い合わせフォームを通じて、お名前、メールアドレス、電話番号などの個人情報を収集することがあります。
              これらの情報は、お客様からのお問い合わせに対応するためにのみ使用し、その他の目的では使用いたしません。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-xl font-medium text-foreground-800 mb-4">
              2. 個人情報の利用目的
            </h2>
            <p className="text-foreground-600 text-sm leading-loose mb-3">
              当社が収集した個人情報は、以下の目的で利用いたします。
            </p>
            <ul className="list-disc list-inside text-foreground-600 text-sm leading-loose space-y-1.5 pl-2">
              <li>お客様からのお問い合わせに対する回答およびご連絡</li>
              <li>当社サービスの提供およびご案内</li>
              <li>サービス向上のための分析・改善</li>
              <li>法令に基づく対応</li>
            </ul>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-xl font-medium text-foreground-800 mb-4">
              3. 個人情報の第三者提供
            </h2>
            <p className="text-foreground-600 text-sm leading-loose">
              当社は、法令に基づく場合を除き、お客様の同意なく個人情報を第三者に提供することはありません。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-xl font-medium text-foreground-800 mb-4">
              4. 個人情報の管理
            </h2>
            <p className="text-foreground-600 text-sm leading-loose">
              当社は、収集した個人情報を適切に管理し、不正アクセス、紛失、漏洩、改ざんなどの防止のために
              必要かつ適切なセキュリティ対策を講じます。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-xl font-medium text-foreground-800 mb-4">
              5. アクセス解析ツールについて
            </h2>
            <p className="text-foreground-600 text-sm leading-loose">
              当サイトでは、サイトの利用状況を把握するためにアクセス解析ツールを使用する場合があります。
              これにより収集される情報は匿名であり、個人を特定するものではありません。
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-xl font-medium text-foreground-800 mb-4">
              6. お問い合わせ先
            </h2>
            <p className="text-foreground-600 text-sm leading-loose mb-2">
              本プライバシーポリシーに関するお問い合わせは、下記までご連絡ください。
            </p>
            <div className="bg-background-100 rounded-xl p-5 mt-4 space-y-1.5">
              <p className="text-foreground-700 text-sm">
                <strong>合同会社RSE</strong>
              </p>
              <p className="text-foreground-600 text-sm">
                〒161-0033 東京都新宿区下落合一丁目15番20-801号
              </p>
              <p className="text-foreground-600 text-sm">
                <a href="mailto:admin@rse-tko.com" className="text-primary-600 hover:text-primary-700 transition-colors">
                  admin@rse-tko.com
                </a>
              </p>
              <p className="text-foreground-600 text-sm">
                <a href="tel:050-8896-3509" className="text-primary-600 hover:text-primary-700 transition-colors">
                  050-8896-3509
                </a>
              </p>
            </div>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-xl font-medium text-foreground-800 mb-4">
              7. プライバシーポリシーの変更
            </h2>
            <p className="text-foreground-600 text-sm leading-loose">
              当社は、必要に応じて本プライバシーポリシーを改定することがあります。
              変更がある場合は、当サイト上でお知らせいたします。
            </p>
          </section>

        </div>
      </div>
      <Footer />
    </main>
  );
}
